export default __webpack_public_path__ + "static/media/close.ed533f6e.svg";